// removed by extract-text-webpack-plugin
module.exports = {"circleContainer":"circleContainer","circleContainer__center":"circleContainer__center","circleContainer__center--first":"circleContainer__center--first","flicker__one":"flicker__one","circleContainer__center--second":"circleContainer__center--second"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructions/CircleAnimation/circleAnimation.scss
// module id = 568
// module chunks = 0